import { RiskGroupShortCodeEnum } from '@olv/ui-shared/enums/risk-group-short-code.enum';
import { WalletBalances } from '@olv/ui-shared/models/wallet.model';

export interface WalletViewModel {
  id: string;
  name: string;
  address: string;
  networkType: number;
  balance: WalletBalances;
  risk?: string;
  pending?: boolean;
  nonce?: number;
  isExternalWallet: boolean;
  isActive: boolean;
  isSweepingEnabled?: boolean;
  riskGroupShortCode?: RiskGroupShortCodeEnum | null;
  lifecycleState?: number;
  isServing?: boolean;
}

export interface OneTimeWalletViewModel {
  id: string;
  address: string;
  networkType: number;
  name: string;
  interactionDate: string;
  withdrawalType: string;
  riskLevel: string;
  status: string;
  balance: WalletBalances;
  isActive?: boolean;
}

export interface ApiWalletViewModel extends OneTimeWalletViewModel {
  walletTypeLabel: string;
}
